import { render, staticRenderFns } from "./BusinessnewsReply.vue?vue&type=template&id=6c8b8940"
import script from "./BusinessnewsReply.vue?vue&type=script&lang=js"
export * from "./BusinessnewsReply.vue?vue&type=script&lang=js"
import style0 from "./BusinessnewsReply.vue?vue&type=style&index=0&id=6c8b8940&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports